import {TextField} from "@mui/material";
import {useField} from "formik";

const DateTimeFieldWrapper = ({
    name,
    ...otherProps}) => {

    const [field, meta] = useField(name);

    const config = {
        ...field,
        ...otherProps,
        type: 'date',
        variant: 'outlined',
        fullWidth: true,
        InputLabelProps: {
            shrink: true
        }
    }

    if (meta && meta.touched && meta.error) {
        config.error = true;
        config.helperText = meta.error;
    }

    return (
        <TextField {...config}/>
    )
}

export default DateTimeFieldWrapper;
